import { createGlobalStyle } from 'styled-components';
import '@/assets/fonts/index.css';

const MobileStyle = createGlobalStyle`
  div {
    display:flex;
    flex-direction: column;
    font-size:5vw;
    height:90vh;
    justify-content: center;
    text-align: center
  }
`;

export default MobileStyle;
